import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { UpdateEntityStateMessage } from './preferred-profession.messages';
import { selectPreferredProfessionTempState } from './preferred-profession.selectors';
import { UpdateEntityStatePreferredProfessionSignal } from './preferred-profession.signals';

@Injectable()
export class PreferredProfessionEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);

  updateEntityStatePreferredProfessionSignal$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UpdateEntityStatePreferredProfessionSignal>(
        UpdateEntityStatePreferredProfessionSignal.TYPE,
      ),
      concatLatestFrom(() => this.store.pipe(select(selectPreferredProfessionTempState))),
      map(
        ([_, preferredProfessionTempState]) =>
          new UpdateEntityStateMessage({
            preferredProfessionTempState,
          }),
      ),
    ),
  );
}
